<template>
  <v-card flat>
    <v-row class="mx-auto text-center py-0"  align="center" justify="space-around" no-gutters>
      <v-col v-for="item in context" :key="item.title" md="2" cols="4" class="px-2 mx-1">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon class="pointer" left v-on="on">{{ item.icon }}</v-icon>
          </template>
          <span>{{ $vuetify.lang.t(item.title) }}</span>
        </v-tooltip>
        {{ item.value(rawValues, event.context) }}
        <span v-html="$vuetify.lang.t(item.postfix)"></span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { CriticalEvent } from '../../../models/map/CriticalEvent'
import { mdiFilterPlus, mdiHelpBox, mdiMapMarkerDistance, mdiRocket, mdiSpeedometerMedium } from '@mdi/js'

import Vuetify from '../../../plugins/vuetify'

export default {
  name: 'criticalContext',
  props: {
    event: CriticalEvent,
    rawValues: Boolean,
    nanoUser: Boolean
  },
  data: () => ({
    mdiHelpBox: mdiHelpBox,
    headers: [
      {
        text: Vuetify.framework.lang.t('$vuetify.shared.field'),
        value: 'field'
      },
      {
        text: Vuetify.framework.lang.t('$vuetify.shared.value'),
        value: 'value'
      }
    ],

  }),
  computed: {
    context () {
      const data = [
        {
          title: '$vuetify.map.criticalPopup.sections.context.averageSpeed.title',
          icon: mdiSpeedometerMedium,
          postfix: '$vuetify.map.criticalPopup.sections.context.averageSpeed.postfix',
          value: (rawValues, context) => !rawValues ? context.fixedField('averageSpeed') : context.averageSpeed
        },
        {
          title: '$vuetify.map.criticalPopup.sections.context.averageAcceleration.title',
          icon: mdiRocket,
          checker: () => !this.nanoUser,
          postfix: '$vuetify.map.criticalPopup.sections.context.averageAcceleration.postfix',
          value: (rawValues, context) => !rawValues ? context.fixedField('averageAcceleration') : context.averageAcceleration
        },
        {
          title: '$vuetify.map.criticalPopup.sections.context.maxAcceleration.title',
          icon: mdiFilterPlus,
          checker: () => !this.nanoUser,
          postfix: '$vuetify.map.criticalPopup.sections.context.maxAcceleration.postfix',
          value: (rawValues, context) => !rawValues ? context.fixedField('maxAcceleration') : context.maxAcceleration
        },
        {
          title: '$vuetify.map.criticalPopup.sections.context.minAcceleration.title',
          icon: mdiMapMarkerDistance,
          checker: () => !this.nanoUser,
          postfix: '$vuetify.map.criticalPopup.sections.context.minAcceleration.postfix',
          value: (rawValues, context) => !rawValues ? context.fixedField('minAcceleration') : context.minAcceleration
        }
      ]

      return data.filter(entry => !entry.hasOwnProperty('checker') || entry.checker())
    }
  }
}
</script>

<style scoped>
  .cell_width {
    min-width: 60px;
  }
</style>
